import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles(() => ({
  modal: {
    '& .MuiDialog-paper': {
      width: '600px',
      maxWidth: '100%',
    },
  },
  modalContent: {
    padding: '0 24px 24px !important',
    overflowY: 'auto' as const,
    maxHeight: '70vh',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px',
  },
  sectionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '16px',
  },
  section: {
    // backgroundColor: STYLE.COLOR.LIGHT_BLUE,
    borderRadius: '8px',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
  },
  sectionHeader: {
    backgroundColor: STYLE.COLOR.LIGHT_BLUE,
    paddingTop: '16px',
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingBottom: '8px',
    display: 'flex',
    flexDirection: 'column' as const,
  },
  sectionHeaderRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    margin: 0,
  },
  sectionCount: {
    fontSize: '12px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT2,
    margin: '2px 0 0',
  },
  sectionLink: {
    fontSize: '12px',
    fontWeight: 500,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    textDecoration: 'underline',
    cursor: 'pointer',
    whiteSpace: 'nowrap' as const,
    flexShrink: 0,
    marginLeft: '8px',
  },
  toggleButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '12px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT1,
    cursor: 'pointer',
    marginTop: '8px',
    marginBottom: '4px',
    '& svg': {
      fontSize: '16px',
    },
  },
  noteBox: {
    backgroundColor: '#FFF8E7',
    border: `1px solid ${STYLE.COLOR.WARNING}`,
    borderLeft: `4px solid ${STYLE.COLOR.WARNING}`,
    borderRadius: '4px',
    padding: '8px 12px',
    marginBottom: '8px',
    marginTop: '8px',
    fontSize: '12px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT1,
    lineHeight: '18px',
    marginLeft: '16px',
  },
  noteText: {
    fontStyle: 'italic',
  },
  noteLabel: {
    fontWeight: 600,
    color: STYLE.COLOR.WARNING,
    marginRight: '4px',
  },
  collapseContent: {
    marginBottom: '12px',
  },
  requirementItem: {
    backgroundColor: STYLE.COLOR.WHITE,
    padding: '0px 16px',
    marginLeft: '16px',
    marginTop: '12px',
    marginBottom: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderLeft: `2px solid ${STYLE.COLOR.BLUE}`,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  requirementItemContent: {
    flex: 1,
    marginRight: '12px',
  },
  requirementItemName: {
    fontSize: '14px',
    fontWeight: 500,
    color: STYLE.COLOR.TEXT1,
    margin: 0,
    lineHeight: '20px',
  },
  requirementItemDescription: {
    fontSize: '12px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT2,
    margin: '2px 0 0',
    lineHeight: '18px',
  },
  missingBadge: {
    backgroundColor: STYLE.COLOR.ERROR_LIGHTER,
    color: STYLE.COLOR.ERROR,
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: '16px',
    padding: '2px 8px',
    borderRadius: '4px',
    textTransform: 'uppercase' as const,
    whiteSpace: 'nowrap' as const,
    flexShrink: 0,
  },
}));
